Drupal.behaviors.header = () => {
  return {
    headerVisible: true,
    lastScrollY: null,

    init() {
      this.setHeaderSizeVariable = this.setHeaderSizeVariable.bind(this);
      this.setHeaderSizeVariable();
    },

    scroll() {
      const { scrollY } = window;
      const headerHeight = this.$el.offsetHeight;

      if (scrollY <= headerHeight || this.lastScrollY === null) {
        this.headerVisible = true;
      } else if (scrollY >= this.lastScrollY) {
        // Scroll direction down
        this.headerVisible = false;
      } else {
        // Scroll direction up
        this.headerVisible = true;
      }
      this.lastScrollY = scrollY;
    },

    setHeaderSizeVariable() {
      const headerHeight = this.$el.offsetHeight;
      document.body.style.setProperty('--headerHeight', headerHeight + "px")
    },
  };
};
